<template>
    <MainContent title="Crear Acreditación">
        <template v-slot:header>
            <h3 class="card-title pb-3">Crear Acreditación</h3>
        </template>
        <template v-slot:content>
            <FormAcreditacion :evento_id="evento_id" :acreditacion="acreditacion" @terminado="crearAcreditacion"/>
            <div class="alert alert-success alert-dismissible mt-3" v-if="url_imprimir">
                <h5><i class="icon fas fa-check mt-2"></i> {{ mensaje }}</h5>
                <div class="row mt-3">
                    <Button :href="config.API_BASE + url_imprimir" class="btn-large float-right" target="_blank">Imprimir</Button>
                    <Button @click.prevent="volver()" class="btn-large float-right ml-4" target="_blank">Volver</Button>
                </div>

            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormAcreditacion from '@/components/backend/acreditaciones/FormAcreditacion';

    export default {
        props: ['evento_id'],
        data() {
            return {
                loading: false,
                acreditacion: {
                    filters: {}
                },
                url_imprimir: '',
                mensaje: ''
            }
        },
        methods: {
            crearAcreditacion(acreditaciónActualizada) {
                this.loading = true;
                this.acreditacion.evento_id = this.evento_id;

                const data = {
                    ...acreditaciónActualizada,
                    evento_id: this.evento_id

                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.crear'), data).then(res => {
                    this.$toast.success(res.data.message);
                    this.mensaje = res.data.message;
                    this.url_imprimir = res.data.acreditacion.url_imprimir + '&tid=' + this.configuracion.hash_teatro;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            volver() {
                this.$router.go(-1);
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        components: {
            MainContent, FormAcreditacion
        }
    }
</script>
